import { BasedClient, useClient } from '@based'
import {
  AnalyticsEvent,
  type AnalyticsEventType,
  type TrackPayload,
} from '../../../shared/analyticsEvents.js'
import { useLanguage } from './useLanguage.js'
import { hashObjectIgnoreKeyOrder } from '@saulx/hash'
import { useSession } from './useSession.js'

const THROTTLE_MS = 3000
let pagehideRegistered = false
let isDraining = false
let drainTimer: ReturnType<typeof setTimeout>
let block = false
const batch: Map<
  number,
  { key: string; payload: TrackPayload; count: number }
> = new Map()

const drain = (client: BasedClient) => {
  drainTimer = setTimeout(() => {
    if (block) {
      return
    }
    let i = 3
    for (const [hash, { key, payload, count }] of batch) {
      if (count > 1) {
        payload.target + '#' + count

        try {
          client.channel('track', key).publish(payload)
        } catch (e) {
          console.warn('Failed to sent event', e)
        }
      } else {
        try {
          client.channel('track', key).publish(payload)
        } catch (e) {
          console.warn('Failed to sent event', e)
        }
      }
      i++
      batch.delete(hash)
      if (i--) break
    }
    if (batch.size > 0) {
      drain(client)
    } else {
      isDraining = false
    }
  }, THROTTLE_MS)
}

const sendEvent = (client: BasedClient, key: string, payload: TrackPayload) => {
  const hash = hashObjectIgnoreKeyOrder({ key, payload })
  let val = batch.get(hash)
  if (!val) {
    batch.set(hash, { key, payload, count: 1 })
  } else {
    val.count++
    if (val.count > 1000) {
      block = true
      isDraining = true
    }
  }
  if (!isDraining) {
    isDraining = true
    drain(client)
  }
}

const addPageHideEventListener = (client: BasedClient) => {
  if (pagehideRegistered || typeof window === 'undefined') return
  pagehideRegistered = true
  window.addEventListener('pagehide', () => {
    clearTimeout(drainTimer)
    let i = 3
    for (const [, { key, payload }] of batch) {
      try {
        client.channel('track', key).publish(payload)
      } catch (e) {
        console.warn('Failed to send event (2)', e)
      }
      if (i--) break
    }
    try {
      client.channel('track', 'disconnect').publish({
        eventType: AnalyticsEvent.DISCONNECT,
        target: undefined,
      })
    } catch (e) {
      console.warn('Failed to sent exit event', e)
    }
  })
}

export const useTrack = (pageKey: string) => {
  const client = useClient()
  const [lang] = useLanguage()
  const [session] = useSession()
  addPageHideEventListener(client)
  return (eventType: AnalyticsEventType, target?: string) => {
    if (!pageKey) return
    sendEvent(client, pageKey, {
      eventType,
      target: target?.slice(0, 32),
      lang: lang.code,
      session,
    })
  }
}
